// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"05745401","488":"e7d261dc","796":"61a6dde2"}[chunkId] + ".chunk.js";
};